import api from '@/http'
import { find } from 'lodash'
import axios from 'axios'
import crypto from 'crypto-js'
import { Str } from 'laravel-js-str'

export default {
  async requestAuthorization (context, params = {}) {
    // await revokeToken()

    localStorage.state = localStorage.state || Str.random(40)
    localStorage.codeVerifier = localStorage.codeVerifier || Str.random(128)
    localStorage.intended = window.location.pathname !== '/oauth/login' ? `${window.location.pathname}${window.location.search}` : window.location.search

    const host = process.env.VUE_APP_ROOT_API

    await context.dispatch('fetchSystem')

    const query = new URLSearchParams({
      client_id: context.state.system.oauth_client_id,
      redirect_uri: `${window.location.protocol}//${window.location.host}/oauth/login`,
      response_type: 'code',
      scope: '*',
      state: localStorage.state,
      code_challenge: crypto.SHA256(localStorage.codeVerifier).toString(crypto.enc.Base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ''),
      code_challenge_method: 'S256'
    })

    const query2 = new URLSearchParams({
      r: `/oauth/authorize?${query}`,
      force: params.force === undefined ? true : params.force,
      direct: params.direct === undefined ? false : params.direct
    })

    window.location.href = `${host}/login?${query2}`
  },

  async getToken (context, { state, code }) {
    const localState = localStorage.state
    const codeVerifier = localStorage.codeVerifier
    localStorage.removeItem('state')
    localStorage.removeItem('codeVerifier')
    if (localState !== state) {
      return Promise.reject(new Error('Unexpected state'))
    }

    const host = process.env.VUE_APP_ROOT_API

    const response = await axios.post(`${host}/oauth/token`, {
      grant_type: 'authorization_code',
      client_id: context.state.system.oauth_client_id,
      redirect_uri: `${window.location.protocol}//${window.location.host}/oauth/login`,
      code_verifier: codeVerifier,
      code: code
    })

    localStorage.accessToken = response.data.access_token
    localStorage.refreshToken = response.data.refresh_token

    return Promise.resolve(response)
  },

  fetchSystem (context) {
    return api.get('/system')
      .then((response) => {
        context.commit('storeBranding', response.data.branding)
        context.commit('storeSystem', response.data)
      })
      .catch((error) => {
        console.log('system', error)
      })
  },

  async bootSystem (context) {
    context.dispatch('setPageLoading', true)

    await context.dispatch('fetchProfile')

    await Promise.all([
      context.dispatch('fetchPages'),
      context.dispatch('fetchArticles'),
      context.dispatch('fetchMenus'),
      context.dispatch('fetchOffices'),
      // log the user's login to product log
      context.dispatch('logUserLogin')
    ])

    await context.dispatch('fetchProfileV2')

    context.dispatch('setPageLoading', false)
    context.commit('setInitialised', true)
  },

  fetchOffices (context) {
    if (!context.state.system || !context.state.system.id) return

    return api
      .get('/offices', { params: { system_id: context.state.system.id } })
      .then((response) => {
        context.commit('setUserOffices', response.data)
        if (!context.state.selectedOffice.id) {
          context.commit('setSelectedOffice', response.data[0])
        } else {
          let office = find(response.data, o => o.id === context.state.selectedOffice.id)
          if (office) {
            context.commit('setSelectedOffice', office)
          } else {
            context.commit('setSelectedOffice', response.data[0])
          }
        }
        context.dispatch('getVideoetteSettings')
        context.dispatch('getUserPreset')
        context.dispatch('fetchActiveAnnualReview')
      })
  },

  fetchArticles (context) {
    return api
      .get('news')
      .then(response => context.commit('setArticles', response.data))
  },

  fetchReferralTerms (context) {
    return api
      .get('referral-terms', {
        params: {
          office_id: context.state.selectedOffice.id
        }
      })
      .then(response => context.commit('setReferralTerms', response.data))
  },

  setSelectedOffice (context, officeId) {
    const office = find(context.state.userOfficeList, function (office) {
      return office.id === officeId
    })
    context.commit('setSelectedOffice', office)
    context.dispatch('getVideoetteSettings')
    context.dispatch('getUserPreset')
  },

  nullActiveProperties (context) {
    context.commit('nullActivePropertiesMutation')
  },

  fetchProfile (context) {
    const gtmTag = context.state.system.gtm_tag

    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('accessToken')) {
        return resolve(null)
      }

      api.get('/profile')
        .then(response => {
          context.commit('updateProfile', response.data)
          // add the user id to ga
          // window.gtag('set', {'user_id': response.data.id});
          let id = response.data.id
          if (typeof (window.gtag) !== 'undefined') {
            window.gtag('config', gtmTag, {
              'user_id': id
            })
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchProfileV2 (context) {
    const gtmTag = context.state.system.gtm_tag

    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('accessToken')) {
        return resolve(null)
      }
      let params = {
        selectedOffice: context.state.selectedOffice.id
      }
      api.get('/profile-v2', {
        params: params
      })
        .then(response => {
          context.commit('updateProfileV2', response.data)
          // add the user id to ga
          // window.gtag('set', {'user_id': response.data.id});
          let id = response.data.id
          if (typeof (window.gtag) !== 'undefined') {
            window.gtag('config', gtmTag, {
              'user_id': id
            })
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchMenus (context) {
    return api.get('/menus').then(response => {
      context.commit('updateMenus', response.data)
    })
  },

  async fetchAdmin (context, filters) {
    await api.get('/admin', {
      params: filters
    }).then(response => {
      context.commit('updateAdmin', response.data)
    })
  },

  deleteAdminItem (context, item) {
    return api.delete(`/admin/${item.id}`, { data: item })
      .then(response => {
        context.commit('removeItem', item)
      })
  },

  fetchPages (context) {
    context.commit('setPagesLoading', true)
    return api.get('/pages').then(response => {
      context.commit('updatePages', response.data)
    }).finally(() => {
      context.commit('setPagesLoading', false)
    })
  },

  setPageLoading (context, value) {
    context.commit('updatePageLoading', value)
  },

  updateProfile (context, data) {
    return api.patch('/profile', data).then(response => {
      context.commit('updateProfile', response.data)
    })
  },

  updateProfileV2 (context, data) {
    data['office_id'] = context.state.selectedOffice.id
    context.state.savingUser = true
    return api.patch('/update-user/' + data.id, data).then(response => {
      context.commit('updateProfileV2', response.data)
      context.state.savingUser = false
    })
  },

  updateProfilePic (context, data) {
    api.post('/profile', data).then(response => {
      context.commit('updateProfile', response.data)
    })
  },

  updateProfilePicV2 (context, data) {
    context.state.uploadingProfilePhoto = true
    api.post('upload-photo/' + context.state.profile_v2.id, data).then(response => {
      context.commit('updateProfileV2', response.data)
      context.state.uploadingProfilePhoto = false
    })
  },

  deleteProfilePic (context, data) {
    api.delete('profile/delete-profile-pic', data).then(response => {
      context.commit('updateProfile', response.data)
    })
  },

  updateAlert (context, data) {
    return new Promise((resolve, reject) => {
      api
        .post('/notification/network/save', data)
        .then(response => {
          context.dispatch('fetchSystem')
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchProperty (context, { propertyId, type }) {
    return new Promise((resolve, reject) => {
      api
        .get(`/properties/${propertyId}`, {
          params: {
            type: type
          }
        })
        .then(response => {
          context.commit('setCurrentProperty', response.data)
          resolve()
        }, error => {
          reject(error)
        })
    })
  },

  fetchGTMTag (context) {
    if (context.state.system && context.state.system.gtm_tag) {
      const gtmTag = context.state.system.gtm_tag;

      (function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        var f = d.getElementsByTagName(s)[0]
        var j = d.createElement(s)
        var dl = l !== 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', gtmTag)
      window.gtag = function () {
        window.dataLayer.push(arguments)
      }
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href
      })
    } else {
      console.error('GTM Tag not found in system object.')
    }
  },

  updateProperty (context) {
    return api.patch(`/properties/${context.state.currentProperty.id}`, context.state.currentProperty).then(response => {
      context.commit('setCurrentProperty', response.data)
    })
  },

  fetchPropertyAgents (context, propertyId) {
    return new Promise((resolve, reject) => {
      api
        .get(`/agents/for-property/${propertyId}`)
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },

  fetchActiveProperties (context, office) {
    if (office !== null) {
      api
        .get(`/offices/${office}`)
        .then(response => {
          context.commit('getActiveProperties', response.data)
        })
    }
  },

  fetchPropertyEnums (context) {
    let self = this
    return new Promise((resolve, reject) => {
      if (self.propertyEnums) {
        resolve()
        return
      }

      api
        .get('/properties/enums')
        .then(response => {
          context.commit('getPropertyEnums', response.data)
          resolve()
        }, error => {
          reject(error)
        })
    })
  },

  fetchProperty24Provinces (context, countryCode) {
    return new Promise((resolve, reject) => {
      if (context.state.property24.provinces.length > 0) {
        resolve()
        return
      }

      api
        .get(`/property24/provinces/${countryCode}`)
        .then(response => {
          context.commit('getProperty24Provinces', response.data)
          resolve()
        }, error => {
          reject(error)
        })
    })
  },

  fetchProperty24Cities (context, provinceId) {
    return new Promise((resolve, reject) => {
      if (context.state.property24.cities[provinceId]) {
        resolve()
        return
      }

      api
        .get(`/property24/cities/${provinceId}`)
        .then(response => {
          context.commit('getProperty24Cities', {
            provinceId: provinceId,
            cities: response.data
          })
          resolve()
        }, error => {
          reject(error)
        })
    })
  },

  fetchProperty24Suburbs (context, cityId) {
    return new Promise((resolve, reject) => {
      if (context.state.property24.suburbs[cityId]) {
        resolve()
        return
      }

      api
        .get(`/property24/suburbs/${cityId}`)
        .then(response => {
          context.commit('getProperty24Suburbs', {
            cityId: cityId,
            suburbs: response.data
          })
          resolve()
        }, error => {
          reject(error)
        })
    })
  },

  geocode (context, location, country) {
    return new Promise((resolve, reject) => {
      country = country || 'GB'

      api
        .get('/geocode', {
          params: {
            location: location,
            country: country
          }
        })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },

  fetchMarketingPackNotifications (context) {
    if (!context.state.selectedOffice) {
      return
    }

    api
      .get(`/marketing-packs/notifications`, {
        params: {
          office_id: context.state.selectedOffice.id
        }
      })
      .then(response => {
        context.commit('getMarketingPackNotifications', response.data)
      })
  },

  fetchActiveAnnualReview (context) {
    if (!context.state.selectedOffice) {
      return
    }

    api.get('/annual-reviews/active-review', {
      params: {
        office_id: context.state.selectedOffice.id
      }
    })
      .then(response => {
        context.commit('setActiveAnnualReview', response.data)
      })
  },

  logout (context) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    context.dispatch('requestAuthorization')
  },

  displayToastNotification (context, notification) {
    context.commit('setToastNotification', notification)
  },

  notifyAdmin (context) {
    api
      .post('notify-admin')
      .then(() => {
        context.commit('setToastNotification', {
          type: 'success',
          icon: 'fa-check',
          title: 'Thanks!',
          info: 'We\'ve notifed our support team'
        })
      })
      .catch(() => {
        context.commit('setToastNotification', {
          type: 'warning',
          icon: 'fa-bell',
          title: 'Unable to send your request',
          info: 'We\'ve been unable to send your request to our support team, please try again shortly.'
        })
      })
  },

  updateUserOffice (context, office) {
    api.put(`/offices/${office.id}`, office)
      .then(({ data }) => {
        context.commit('updateUserOffice', data)
      })
  },

  authInsight (context) {
    api
      .post('insight')
      .then(response => {
        let newTab = window.open()
        newTab.location.href = response.data.url
      })
      .catch(({ response }) => {
        let errorMsg = response.data.message
        if (response.status === 404) {
          errorMsg = 'No insight user found, please contact support.'
        }
        context.dispatch('displayToastNotification', {
          type: 'warning',
          icon: 'fa-bell',
          title: 'Authentication Failed',
          info: errorMsg
        })
      })
  },

  authGoldMarketingPack (context) {
    api.get('/legacy-members-hub/login', {
      params: {
        office_id: context.state.selectedOffice.id,
        redirect: '/forms/gold-service'
      }
    }).then((response) => {
      this.loading = false
      window.open(response.data.url)
    }, () => {
      this.loading = false
      context.dispatch('displayToastNotification', {
        type: 'danger',
        icon: 'fa-times-circle',
        title: 'Gold Marketing Pack',
        info: 'Sorry, we\'re unable to log you into the old members hub right now. Please try again later.'
      })
    })
  },

  ssoToEasyProperty (context) {
    api
      .get('easyproperty/sso/dashboard')
      .then(response => {
        let newTab = window.open()
        newTab.location.href = response.data.url
      })
      .catch(({ response }) => {
        context.dispatch('displayToastNotification', {
          type: 'warning',
          icon: 'fa-bell',
          title: 'Error',
          info: 'There was an errror redirecting you, please try again later'
        })
      })
  },

  fetchNotifications (context) {
    return new Promise((resolve, reject) => {
      if (context.state.notifications) {
        resolve()
        return
      }

      api
        .get('/notification', {
          params: {
            client_id: context.state.selectedOffice.client_id
          }
        })
        .then(response => {
          context.commit('setNotifications', response.data)
          resolve()
        }, error => {
          reject(error)
        })
    })
  },

  getVideoettes (context, options = {}) {
    return api
      .get('/videoettes', options)
      .then(response => {
        context.commit('storeVideoettes', response.data, options.params.page)
        return response
      })
  },

  getVideoetteSettings (context) {
    return api
      .get(`/office/${context.state.selectedOffice.id}/videoette-settings`)
      .then(response => {
        context.commit('updateVideoetteSettings', response.data)
        return response
      })
  },

  getPreset (context, type = 'videoette') {
    return api
      .get(`office/${context.state.selectedOffice.id}/preset`, {
        params: { type: type }
      })
      .then(response => {
        context.commit('setOfficePreset', response.data, type)
        return response
      })
  },

  getUserPreset (context, type = 'social') {
    return api
      .get(`office/${context.state.selectedOffice.id}/branding-preset`, {
        params: { type: type }
      })
      .then(response => {
        context.commit('setOfficePreset', response.data, type)
        return response
      })
  },

  saveVideoBrandingPreset (context) {
    const preset = context.state.selectedVideoBradingOption

    if (context.state.savingBrandingPresets) {
      context.state.savingBrandingPresets.cancel()
    }

    let source = axios.CancelToken.source()
    context.commit('setSavingBrandingPresets', source)

    return api
      .post(`office/${context.state.selectedOffice.id}/branding-preset`, {
        type: 'social',
        logo_animation_id: preset.logo ? preset.logo.id : null,
        transition_id: preset.transition ? preset.transition.id : null,
        branding_id: preset.branding ? preset.branding.id : null,
        backing_music_ids: preset.backingMusic ? preset.backingMusic.map(o => o.id) : [],
        presenter_enabled: preset.showPresenter || false
        // transition_id: preset.transition.id,
        // logo_animation_colour: this.logoColour,
      }, {
        cancelToken: source.token
      })
      .then(response => {
        context.commit('setSavingBrandingPresets', null)
        return response
      })
      .catch(error => {
        if (!axios.isCancel(error)) {
          context.commit('setSavingBrandingPresets', null)
        }

        return error
      })
  },

  setActiveChildMenu ({ commit }, slug) {
    commit('setActiveChildMenu', slug)
  },

  deleteMenu ({ commit }, menu) {
    commit('deleteMenu', menu)
  },

  getAvailabilityTimes ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      api.get('/availability', {
        params: {
          type: params.type,
          officeID: state.selectedOffice.id,
          offset: params.weekOffset
        }
      }).then(({ data }) => {
        commit('setAvailabilityTimes', data.times)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },

  updateAvailabilityTime ({ commit, state }, block) {
    return new Promise((resolve, reject) => {
      api.post('/availability/update', {
        officeID: state.selectedOffice.id,
        ...block
      }).then(({ data, status }) => {
        if (status === 201) {
          commit('replaceNewAvailabilityTime', data)
        } else {
          commit('updateAvailabilityTime', data)
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  deleteAvailabilityTime ({ commit }, block) {
    return new Promise((resolve, reject) => {
      api.post(`/availability/${block.time.id}/delete`, {
        offset: block.offset
      }).then(({ data }) => {
        commit('deleteAvailabilityTime', block.time)
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  toggleRepeatingAvailabilityTime ({ commit }, block) {
    let method = block.oldType === 2 ? 'disable-repeat' : 'repeat'
    return new Promise((resolve, reject) => {
      api.post(`/availability/${block.time.id}/${method}`)
        .then(({ data }) => {
          commit('updateAvailabilityTime', block.time)
          resolve(data)
        }).catch(err => {
          reject(err)
        })
    })
  },

  setAvailabilityTimes ({ commit }, times) {
    commit('setAvailabilityTimes', times)
  },

  addAvailabilityTime ({ commit }, payload) {
    commit('addAvailabilityTime', payload)
  },

  logPageView (route, context) {
    if (!context.state.selectedOffice.id) {
      return
    }
    api.post(process.env.VUE_APP_ROOT_API + '/data/product-use-log', {
      'network_id': context.state.selectedOffice.network_id,
      'client_id': context.state.selectedOffice.client_id,
      'office_id': context.state.selectedOffice.id,
      'product': 'Members Hub',
      'category_type': 'page_view',
      'category_value': route,
      'action_type': 'read',
      'quantity': 1
    })
  },

  logUserLogin (context) {
    if (!context.state.selectedOffice.id || !context.state.profile_v2) {
      return
    }
    if (localStorage.getItem('loginFlag')) {
      return
    }
    api.post(process.env.VUE_APP_ROOT_API + '/data/product-use-log', {
      'network_id': context.state.selectedOffice.network_id,
      'client_id': context.state.selectedOffice.client_id,
      'office_id': context.state.selectedOffice.id,
      'product': 'Members Hub',
      'category_type': 'login',
      'category_value': '',
      'action_type': 'login',
      'user_id': context.state.profile_v2.id,
      'quantity': 1
    }).then(function () {
      localStorage.setItem('loginFlag', true)
    })
  }
}
